import request from '@/plugins/axios'// 行业求购
//列表
export const apiIndustryLists = (params: any) => request.get('/shop.Industry/lists', {params})
//商城列表页面
export const apiShopLists = (params: any) => request.get('/shop.shop/lists', {params})

// 添加 
export const apiIndustryAdd = (params: any) => request.post('/shop.Industry/add', params)
// 编辑
export const apiIndustryEdit  = (params: any) => request.post('/shop.Industry/edit', params)
// 删除
export const apiIndustryDel = (params: any) => request.post('/shop.Industry/delete', params)
// 详情
export const apiIndustryDetail = (params: any) => request.get('/shop.Industry/detail', {params})


//采集
export const apiCollection = (params: any) => request.get('/shop.Industry/collection', {params})
